// extracted by mini-css-extract-plugin
export default {"title":"AccountsPayableDetails_title__An4ly","pay":"AccountsPayableDetails_pay__NmVyM"};